"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentsGateways = void 0;
exports.paymentsGateways = [
    'paypal'
    // 'stripe'
];
